import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export const fillerScroll = () => {
   const filler = document.querySelector('#js-scrollFiller');
   if (!filler) return false;
   ScrollTrigger.create({
      trigger: '#content',
      start: 'top center',
      endTrigger: '#content',
      end: 'bottom center',
      onUpdate: (self) => {
         filler.style.height = 100 * self.progress.toFixed(3) + '%';
      },
   });
};
